import { useContext } from 'react'

import {
  Button,
  Columns,
  LoadingModule,
  SaveFormModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useTaskListTemplate, { useTaskListTemplateForm } from '@hooks/useTaskListTemplate'

import defaultRequestOptions from '@sections/Admin/packs/QualityControl/defaultRequestOptions'

import PageLayout from '../../../../components/PageLayout'

import Assets from '../Assets'
import Links from '../Links'
import TaskListTemplateDetails from '../TaskListTemplateDetails'
import TaskListTemplateSections from '../TaskListTemplateSections'

interface PageContentProps {
  taskListTemplateId: number,
}

const PageContent = (props: PageContentProps) => {
  const { taskListTemplateId } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      updateTaskListTemplate,
    },
  } = pageContext

  const taskListTemplatePayload = useTaskListTemplate({ id: taskListTemplateId }, {
    requestOptions: {
      ...defaultRequestOptions.taskListTemplate,
    },
  })

  const {
    taskListTemplate,
    callbacks: {
      updateTaskListTemplate: updateFn,
    },
    loading,
    updating,
  } = taskListTemplatePayload

  const taskListTemplateFormPayload = useTaskListTemplateForm(taskListTemplate)
  const { entityState, saveEnabled } = taskListTemplateFormPayload

  const updateTaskListTemplatePayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Task List Template Updated',
  }

  return (
    <PageLayout taskListTemplatePayload={taskListTemplatePayload} activeTabBarItemKey="details">
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {!loading && (
          <>
            <TaskListTemplateDetails taskListTemplateFormPayload={taskListTemplateFormPayload} />
            <TaskListTemplateSections taskListTemplate={taskListTemplate} />

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                // @ts-expect-error TS2322
                marginLeft="auto"
                onClick={() => updateTaskListTemplate(updateTaskListTemplatePayload)}
                size="medium"
              >
                Save Details
              </Button>
            </SaveFormModule>
          </>
        )}
      </Columns.Main>

      <Columns.Sidebar>
        <Assets taskListTemplate={taskListTemplate} />
        <Links taskListTemplate={taskListTemplate} />
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
